module.exports = __webpack_public_path__ + "static/media/preview.683715cc.png";